////////LIBRARY/////////
import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { isUndefined, map, forEach } from 'lodash'
///////COMPONENTS///////
import UseOutsideClick from '../../hooks/UseOutsideClick/UseOutsideClick'
import ActionsPaper from '../../components/Table/components/ActionsPaper'
import Tooltip from '../../components/Tooltip/Tooltip'

/////////STYLED/////////
const ActionsTableWrapper = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	grid-column-gap: 15px;
	height: auto;
	margin-left: 8px;
`
const ActionsImage = styled.img`
	cursor: pointer;
	max-height: 19px;
`
const IconToBg = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	background-color: ${(props) => props.bgColor};
	background-image: url(${(props) => props.icon});
	background-repeat: no-repeat;
	background-position: center;
	cursor: ${(props) => (props.canClick ? 'pointer' : '')};
	:hover {
		background-color: ${(props) => props.hover};
	}
	transition: background-color 0.1s;
`
/////////STYLED/////////

const ActionsTable = (props) => {
	const [showPaper, setShowPaper] = useState(false)
	const [forIconsColl, setForIconsColl] = useState([])
	const [forActionButtonColl, setForActionButtonColl] = useState([])
	const actionsList = props.paperActionsList
	const tooltipPart = props.column.tooltipPart

	const [isIconVisible, setIsVisibleIcon] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleOpenShowPaper = () => {
		setShowPaper(!showPaper)
	}
	const refDropdownCheckbox = useRef()
	UseOutsideClick(refDropdownCheckbox, () => {
		setShowPaper(false)
		//props.setStateToggleActions(false)
	})

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// We cannot cloneDeep each time, because we only use push actions to fill those arrays
		// We will have duplicate actions at some time
		//const forIconsCollCp = cloneDeep(forIconsColl)
		//const forActionButtonCollCp = cloneDeep(forActionButtonColl)
		const forIconsCollCp = []
		const forActionButtonCollCp = []

		forEach(actionsList, (elem, _k) => {
			if (elem.isVisible(props.row)) {
				forActionButtonCollCp.push(elem)
			}
			if (elem.isVisible(props.row) && forIconsCollCp.length < 2) {
				if (!isUndefined(elem.iconDef) || forIconsCollCp.length === 1 || (!isUndefined(elem.icon) && !elem.iconDef)) {
					forIconsCollCp.push(elem)
				}
			}
		})

		setForIconsColl(forIconsCollCp)
		setForActionButtonColl(forActionButtonCollCp)
	}, [actionsList, props.row])

	/* 	forEach(actionsList, (elem, k) => {
	
			if (!isUndefined(elem.isVisible(props.row))) {
			}
			if (elem.isVisible(props.row)) {
				forActionButtonColl.push(elem)
			}
			if (elem.isVisible(props.row) && forIconsColl.length < 2) {
				if (!isUndefined(elem.iconDef) || forIconsColl.length === 1 || (!isUndefined(elem.icon) && !elem.iconDef)) {
					forIconsColl.push(elem)
				}
			}
		}) */

	// To determine if we can display 3 dot we must listen withIcons props and loop inside action list
	// if isVisible === true we set a state to true
	useEffect(() => {
		forEach(actionsList, (elem, _k) => {
			if (!props.column.withIcons && elem.isVisible(props.row)) {
				setIsVisibleIcon(true)
			}
		})
	}, [props.column.withIcons])

	///////////////////////////////// RENDER ///////////////////////////////////////
	// we add a test to force display tree dot button in case of we dont receive icon
	return (
		<ActionsTableWrapper>
			{forActionButtonColl.length > 2 || props.forceActionsList || isIconVisible ? (
				<ActionsPaper
					hasRef={refDropdownCheckbox}
					handlePaper={handleOpenShowPaper}
					actionsList={props.paperActionsList}
					indexRow={props.indexRow}
					dataSize={props.dataSize}
					stateShowPaper={showPaper}
					row={props.row}
					notInNested={true}
					isWithActionIcons={true}
					tooltipConfig={{
						tooltipId: `${tooltipPart}_actions_rowid_${props.indexRow}`,
						translationsKey: 'tooltip__admin__global__showActions',
						position: 'left',
					}}
				/>
			) : null}
			{map(forIconsColl, (elem, k) =>
				!isUndefined(elem.clickAction) ? (
					<Tooltip
						translationsKey={elem.translationKey}
						tooltipId={`${tooltipPart}_actions_rowid_${props.indexRow}_${k}`}
						position={'left'}
					>
						{elem.bgColor ? (
							<IconToBg
								canClick={true}
								icon={elem.icon}
								hover={elem.hover}
								bgColor={elem.bgColor}
								onClick={() => !isUndefined(elem.clickAction) && elem.clickAction(props.row)}
							/>
						) : (
							<ActionsImage
								src={elem.iconDef || elem.icon}
								onClick={() => !isUndefined(elem.clickAction) && elem.clickAction(props.row)}
							/>
						)}
					</Tooltip>
				) : null
			)}
		</ActionsTableWrapper>
	)
}
ActionsTable.propTypes = {}

ActionsTable.defaultPropTypes = {}

export default ActionsTable
